// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Tv7x","textarea":"styles_textarea__1t0-2"};